import config from '../../config';

export default {
  url: `${config.api.baseURL}/requests`,
  transformer(data) {
    return data;
  }
};
